import type { GameSave } from '@brick-rogue/persistence';

import { useCampaignProgressStore } from '../levels/campaignProgressStore';
import { useUiPreferencesStore } from '../settings/uiPreferencesStore';

export function applySaveToRuntime(save: GameSave): void {
  useCampaignProgressStore.getState().hydrate(save.campaign);
  useUiPreferencesStore.getState().hydrate(save.preferences);
}
